import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  // Button base styles
  button: {},
  buttonSmall: {
    width: 34,
    height: 34,
    borderRadius: 12,
    padding: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonDefault: {
    width: 44,
    height: 44,
    borderRadius: 12,
    padding: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },

  // Icon styles
  iconSmall: {
    width: 16,
    height: 16,
  },
  iconDefault: {
    width: 16,
    height: 16,
  },
  iconHover: {},
  iconDisabled: {},
  iconPressed: {},

  wrapper: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  buttonAbsolute: {
    position: 'absolute',
    width: '100%',
  },
});
